import {combineReducers, configureStore} from "@reduxjs/toolkit";
import accountReducer from "./slice/accountSlice";
import liquidationReducer from "./slice/liquidationSlice";
import transactionReducer from "./slice/transactionSlice";
import groupSavingReducer from "./slice/groupSavingsSlice";
import dashboardReducer from "./slice/dashboardSlice";
import paymentLinkReducer from "./slice/paymentLinkSlice";
import billPaymentReducer from "./slice/billPaymentSlice";
import supportTicketReducer from "./slice/supportTicketSlice";
import adminUserReducer from "./slice/adminUserSlice";
import auditTrailReducer from "./slice/auditTrailSlice";
import userManagementReducer from "./slice/userManagementSlice";
import {persistStore, persistReducer} from 'redux-persist';
import storage from 'redux-persist/lib/storage';

const persistConfig = {
    key: 'root',
    storage,
};

const rootReducer: any = combineReducers({
    account: accountReducer,
    liquidation: liquidationReducer,
    transaction: transactionReducer,
    groupSavings: groupSavingReducer,
    dashboard: dashboardReducer,
    paymentLinks: paymentLinkReducer,
    billPayments: billPaymentReducer,
    supportTickets: supportTicketReducer,
    adminUsers: adminUserReducer,
    auditTrail: auditTrailReducer,
    userManagement: userManagementReducer,
});

const persistedReducer = persistReducer<any>(persistConfig, rootReducer);

const store = configureStore({
    reducer: persistedReducer,
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const persistor = persistStore(store);

export default store;
